import React from 'react';

const CarouselContainer = {
  width: '100%',
  overflow: 'hidden',
  margin: '20px 0',
  background: '#1a1a2e'
};

const CarouselRow = {
  width: '100%',
  overflow: 'hidden',
  margin: 0,
  padding: 0,
  position: 'relative',
  lineHeight: 0
};

const ImageTrack = {
  display: 'flex',
  width: 'fit-content',
  margin: 0,
  padding: 0,
  animation: 'scrollLeft 40s linear infinite'  // Changé de 25s à 40s (plus lent)
};

const ImageWrapper = {
  width: '600px',
  height: '600px',
  flexShrink: 0,
  margin: 0,
  padding: 0,
  display: 'block'
};

const CarouselRowComponent = ({ direction, images }) => {
  const seamlessImages = [...images, ...images];
  
  return (
    <div style={CarouselRow}>
      <div style={{
        ...ImageTrack,
        animation: direction === 'left-to-right' ? 'scrollLeft 40s linear infinite' : 'scrollRight 40s linear infinite'  // Changé de 25s à 40s
      }}>
        {seamlessImages.map((image, index) => (
          <div key={index} style={ImageWrapper}>
            <img src={image} alt={`img-${index}`} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', margin: 0, padding: 0 }} />
          </div>
        ))}
      </div>
    </div>
  );
};

const ImageCarousel = () => {
  // Une seule ligne avec TOUTES les 12 images
  const allImages = [
    // Ligne 1 - Images 1 à 4
    '/images/1.jpg',
    '/images/2.jpg',
    '/images/3.jpg',
    '/images/4.jpg',
    // Ligne 2 - Images 5 à 8
    '/images/5.jpg',
    '/images/6.jpg',
    '/images/7.jpg',
    '/images/8.jpg',
    // Ligne 3 - Images 9 à 12
    '/images/9.jpg',
    '/images/10.jpg',
    '/images/11.jpg',
    '/images/12.jpg'
  ];

  // Ajoutez les animations CSS globales
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes scrollLeft {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      
      @keyframes scrollRight {
        0% { transform: translateX(-50%); }
        100% { transform: translateX(0); }
      }
    `;
    document.head.appendChild(style);
  }, []);

  return (
    <div style={CarouselContainer}>
      {/* Une seule ligne qui défile de gauche à droite avec toutes les 12 images */}
      <CarouselRowComponent direction="left-to-right" images={allImages} />
    </div>
  );
};

export default ImageCarousel;